import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Users, DollarSign, Shuffle, MessageSquare, Calendar, Clipboard } from 'lucide-react';
import { usePlanFeatures } from '../../hooks/usePlanFeatures';

const NavigationBar: React.FC = () => {
  const { limits } = usePlanFeatures();
  
  const navLinkClass = ({ isActive }: { isActive: boolean }) => 
    `flex flex-col items-center gap-1 p-2 text-xs font-medium ${
      isActive 
        ? 'text-primary-600 dark:text-primary-400' 
        : 'text-gray-600 dark:text-gray-300'
    }`;

  return (
    <div className="fixed bottom-0 left-0 right-0 flex justify-center z-30 lg:hidden">
      {/* Gradiente de preto para transparente */}
      <div className="absolute bottom-0 left-0 right-0 h-[50px] bg-gradient-to-t from-[#131313] to-transparent pointer-events-none"></div>
      
      <nav className="bg-white/80 dark:bg-dark-paper/80 backdrop-blur-sm rounded-full shadow-lg border dark:border-dark-border relative z-10 mb-5 mx-5">
        <div className="flex items-center justify-between px-6 py-3">
          <NavLink to="/" className={navLinkClass} end>
            <Home className="w-6 h-6" />
            
          </NavLink>
          
          <NavLink to="/jogadores" className={navLinkClass}>
            <Users className="w-6 h-6" />
            
          </NavLink>
          
          <NavLink to="/financeiro" className={navLinkClass}>
            <DollarSign className="w-6 h-6" />
            
          </NavLink>

          <NavLink to="/jogos" className={navLinkClass}>
            <Calendar className="w-6 h-6" />
           
          </NavLink>
          
          <NavLink to="/escalacao" className={navLinkClass}>
            <Clipboard className="w-6 h-6" />
          </NavLink>
          
          <NavLink to="/sorteio" className={navLinkClass}>
            <Shuffle className="w-6 h-6" />
            
          </NavLink>
          
          
          {limits.hasResenha && (
            <NavLink to="/resenha" className={navLinkClass}>
              <MessageSquare className="w-6 h-6" />
              
            </NavLink>
          )}
        </div>
      </nav>
    </div>
  );
};

export default NavigationBar;